import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'leaflet/dist/leaflet.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initPostHog } from './config/posthog';
import { initPaddle } from './config/paddle';

// Initialize PostHog
initPostHog();

// Initialize Paddle when the page loads
window.addEventListener('load', () => {
  setTimeout(() => {
    initPaddle();
  }, 500); // Small delay to ensure Paddle.js script is loaded
});

// Prevent initial animation flicker
document.documentElement.classList.add('no-transition');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
